var render = function render(){
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('div', {
    staticClass: "mental-health-participant-list"
  }, [_vm.data.length == 0 ? _vm._t("empty", function () {
    return [_c('empty-state')];
  }) : _c('div', {
    staticClass: "px-3"
  }, [_c('c-input', {
    attrs: {
      "type": "search",
      "placeholder": _vm.searchPlaceholder
    },
    model: {
      value: _vm.keyword,
      callback: function callback($$v) {
        _vm.keyword = $$v;
      },
      expression: "keyword"
    }
  }), _vm.filteredData.length == 0 ? _c('p', {
    staticClass: "text-gray",
    attrs: {
      "align": "center"
    }
  }, [_vm._v("\n      Tidak ada data dengan kata kunci yang dicari.\n    ")]) : _vm._e()], 1), _vm._l(_vm.filteredData, function (checkup, index) {
    return _c('div', {
      key: checkup.id,
      staticClass: "pointer",
      on: {
        "click": function click($event) {
          return _vm.onItemClick(checkup);
        }
      }
    }, [_c('div', {
      staticClass: "px-3 py-2"
    }, [_c('p', {
      staticClass: "mb-3"
    }, [_vm._v(_vm._s(checkup.problem.substr(0, 100)) + "...")]), _c('div', {
      staticClass: "d-flex align-items-center flex-wrap"
    }, [_vm.showName ? _c('span', {
      staticClass: "badge badge-primary flex-shrink-0 d-inline-flex align-items-center mb-1 mr-1"
    }, [_c('material-icon', {
      staticClass: "mr-1",
      attrs: {
        "name": "person",
        "type": "rounded",
        "size": "12"
      }
    }), _vm._v("\n          " + _vm._s(checkup.user.fullname) + "\n        ")], 1) : _vm._e(), _vm.showStatusBadge ? _c('span', {
      staticClass: "badge mr-1 mb-1",
      class: _vm.getCheckupBadge(checkup.status)
    }, [_vm._v("\n          " + _vm._s(_vm.capitalize(_vm.getCheckupStatusIndo(checkup.status))) + "\n        ")]) : _vm._e(), checkup.status == 'unscheduled' ? _c('span', {
      staticClass: "badge flex-shrink-0 d-inline-flex align-items-center mb-1 text-gray"
    }, [_c('material-icon', {
      staticClass: "mr-1",
      attrs: {
        "name": "today",
        "type": "rounded",
        "size": "12"
      }
    }), _vm._v("\n          " + _vm._s(_vm.getScheduleOptionText(checkup.schedule.day, checkup.schedule.time_start, checkup.schedule.time_end)) + "\n        ")], 1) : checkup.status != 'canceled' ? [_c('span', {
      staticClass: "badge flex-shrink-0 d-inline-flex align-items-center mr-1 mb-1 text-gray"
    }, [_c('material-icon', {
      staticClass: "mr-1",
      attrs: {
        "name": "event",
        "type": "rounded",
        "size": "12"
      }
    }), _vm._v("\n            " + _vm._s(_vm.formatDateForHuman(checkup.scheduled_at, true)) + "\n          ")], 1), _c('span', {
      staticClass: "badge flex-shrink-0 d-inline-flex align-items-center mr-1 mb-1 text-gray"
    }, [_c('material-icon', {
      staticClass: "mr-1",
      attrs: {
        "name": "schedule",
        "type": "rounded",
        "size": "12"
      }
    }), _vm._v("\n            " + _vm._s(_vm.formatTimeToIndo(checkup.schedule.time_start)) + " -\n            " + _vm._s(_vm.formatTimeToIndo(checkup.schedule.time_end)) + " WIB\n          ")], 1), _c('span', {
      staticClass: "badge flex-shrink-0 d-inline-flex align-items-center mb-1 text-gray"
    }, [_c('material-icon', {
      staticClass: "mr-1",
      attrs: {
        "name": "chair",
        "type": "outlined",
        "size": "12"
      }
    }), _vm._v("\n            " + _vm._s(checkup.room.name) + "\n          ")], 1)] : _vm._e()], 2)]), index != _vm.filteredData.length - 1 ? _c('div', {
      staticClass: "divider"
    }) : _vm._e()]);
  })], 2);

}
var staticRenderFns = []

export { render, staticRenderFns }